// DWLF-427: where a timeframe switch eases to. The chart keeps the date the reader was looking at
// (the right edge of the view) and opens the new timeframe at its usual width there.

const HOUR = 3_600_000;
const DAY = 24 * HOUR;
const SLOT_MS = { hourly: HOUR, daily: DAY, weekly: 7 * DAY };

/** One bar of the timeframe in ms (daily for anything unknown), matching the chart's blank slots. */
export const slotMsFor = (timeframe) => SLOT_MS[(timeframe || '').toLowerCase()] || DAY;

/**
 * The time range a switch to bars `times` (ascending ms) eases to from the range `from` that was on
 * screen, as the chart's pan/zoom would hold it: `visibleBars` slots ending where `from` ended, or
 * the latest bars when `from` reached the last bar. `extraSlots` blank slots follow the last bar.
 * Null when there is nothing to ease between, or `from` ends before the first bar (the hourly
 * history is far shorter than the weekly), so the chart just opens on the latest bars.
 */
export function timeframeSwitchGoal({ from, times, slotMs, visibleBars, extraSlots }) {
  const n = Array.isArray(times) ? times.length : 0;
  if (!from || !(from.endTime > from.startTime) || n === 0 || !(visibleBars > 0)) {
    return null;
  }
  if (from.endTime < times[0]) {
    return null;
  }
  const last = times[n - 1];
  const total = n + Math.max(0, extraSlots || 0);
  const count = Math.min(visibleBars, total);
  const timeAt = (i) => (i < n ? times[i] : last + (i - n + 1) * slotMs);

  let end;
  if (from.endTime >= last) {
    end = total;
  } else {
    // The first bar after from.endTime, so the bar the view ended on stays the last one shown.
    let lo = 0;
    let hi = n;
    while (lo < hi) {
      const mid = (lo + hi) >> 1;
      if (times[mid] <= from.endTime) lo = mid + 1;
      else hi = mid;
    }
    end = Math.max(count, lo);
  }
  const start = end - count;
  return { startTime: timeAt(start), endTime: timeAt(end - 1) };
}
